import { c as _c } from "react/compiler-runtime";
import * as Sentry from '@sentry/react';
import ErrorPage from './ErrorPage';
export const fallbackRender = (props) => <ErrorPage {...props}/>;
export const handleError = (error, componentStack) => {
    Sentry.setExtras({
        error,
        componentStack
    });
};
const ErrorBoundary = (t0) => {
    const $ = _c(8);
    let children;
    let props;
    let t1;
    if ($[0] !== t0) {
        ({ children, fallback: t1, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
        $[3] = t1;
    }
    else {
        children = $[1];
        props = $[2];
        t1 = $[3];
    }
    const fallback = t1 === undefined ? fallbackRender : t1;
    let t2;
    if ($[4] !== children || $[5] !== fallback || $[6] !== props) {
        t2 = <Sentry.ErrorBoundary onError={handleError} fallback={fallback} {...props}>
      {children}
    </Sentry.ErrorBoundary>;
        $[4] = children;
        $[5] = fallback;
        $[6] = props;
        $[7] = t2;
    }
    else {
        t2 = $[7];
    }
    return t2;
};
export default ErrorBoundary;
